import { Route } from "@angular/router";

export const ActivityPaths = {
  List: "overzicht",
  Add: "toevoegen",
  Edit: (activityId: string | number) => "bewerken/" + activityId,
  FinancialOverview: (activityId: string | number) => "financieel-overzicht/" + activityId,
  Participants: (activityId: string | number) => "deelnemers/" + activityId,
};

export default [
  {
    path: ActivityPaths.List,
    loadComponent: () =>
      import("./pages/activities-list/activities-list.component").then(
        (c) => c.ActivitiesListComponent
      ),
    data: {
      breadcrumb: "Activiteiten beheren",
      title: "Activiteiten beheren",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: "list",
    redirectTo: ActivityPaths.List,
  },
  {
    path: ActivityPaths.Add,
    loadComponent: () =>
      import("./pages/activity-edit/activity-edit.component").then((c) => c.ActivityEditComponent),
    data: {
      breadcrumb: "Activiteit toevoegen",
      title: "Activiteit toevoegen",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: ActivityPaths.Edit(":id"),
    loadComponent: () =>
      import("./pages/activity-edit/activity-edit.component").then((c) => c.ActivityEditComponent),
    data: {
      breadcrumb: "Activiteit bewerken",
      title: "Activiteit bewerken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: ActivityPaths.FinancialOverview(":id"),
    loadComponent: () =>
      import("./pages/activity-financial-overview/activity-financial-overview.component").then(
        (c) => c.ActivityFinancialOverviewComponent
      ),
    data: {
      breadcrumb: "Financieel overzicht",
      title: "Financieel overzicht",
      subscriptionTypes: [1],
    },
  },
  {
    path: ActivityPaths.Participants(":id"),
    loadComponent: () =>
      import("./pages/activity-participants-list/activity-participants-list.component").then(
        (c) => c.ActivityParticipantsListComponent
      ),
    data: {
      breadcrumb: "Deelnemers",
      title: "Deelnemers",
      subscriptionTypes: [1, 4],
    },
  },
] satisfies Route[];
